module.exports = __webpack_public_path__ + "img/P150T_weapon_69.a2d8986d.png";